import { render, staticRenderFns } from "./ContentStrapi.vue?vue&type=template&id=c9b5bdaa&scoped=true"
import script from "./ContentStrapi.vue?vue&type=script&lang=js"
export * from "./ContentStrapi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b5bdaa",
  null
  
)

export default component.exports